import { KiteUiCoroutineScopeHelpers25rj47zs39igb as KiteUiCoroutineScopeHelpers } from './KiteUiCoroutineScopeHelpers.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function beforeSetup(_this__u8e3s4, setup) {
  return new (BeforeSetup())(_this__u8e3s4, setup);
}
function split(_this__u8e3s4) {
  return new (Split())(_this__u8e3s4);
}
function beforeSetup_0(_this__u8e3s4, setup) {
  return new (BeforeSetup())(_this__u8e3s4, setup);
}
function beforeSetup_1(_this__u8e3s4, setup) {
  return new (BeforeSetup())(_this__u8e3s4, setup);
}
function beforeSetup_2(_this__u8e3s4, setup) {
  return new (BeforeSetup())(_this__u8e3s4, setup);
}
function beforeSetup_3(_this__u8e3s4, setup) {
  return new (BeforeSetup())(_this__u8e3s4, setup);
}
var BeforeSetupClass;
function BeforeSetup() {
  if (BeforeSetupClass === VOID) {
    class $ {
      constructor(wraps, action) {
        this.wraps_1 = wraps;
        this.action_1 = action;
      }
      willAddChild_hz2iwc_k$(element) {
        this.wraps_1.willAddChild_hz2iwc_k$(element);
        this.action_1(element);
      }
      get_context_h02k06_k$() {
        return this.wraps_1.get_context_h02k06_k$();
      }
      addChild_2qpft2_k$(element) {
        this.wraps_1.addChild_2qpft2_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.wraps_1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.wraps_1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, 'BeforeSetup', VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    BeforeSetupClass = $;
  }
  return BeforeSetupClass;
}
var SplitClass;
function Split() {
  if (SplitClass === VOID) {
    class $ {
      constructor(parent) {
        this.$$delegate_0__1 = parent;
        this.context_1 = parent.get_context_h02k06_k$().split_1ta5ga_k$();
      }
      get_context_h02k06_k$() {
        return this.context_1;
      }
      willAddChild_hz2iwc_k$(element) {
        this.$$delegate_0__1.willAddChild_hz2iwc_k$(element);
      }
      addChild_2qpft2_k$(element) {
        this.$$delegate_0__1.addChild_2qpft2_k$(element);
      }
      invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate) {
        return this.$$delegate_0__1.invoke_bnq13k_k$(_this__u8e3s4, actionToCalculate);
      }
      get_coroutineContext_115oqo_k$() {
        return this.$$delegate_0__1.get_coroutineContext_115oqo_k$();
      }
    }
    initMetadataForClass($, 'Split', VOID, VOID, [KiteUiCoroutineScopeHelpers()]);
    SplitClass = $;
  }
  return SplitClass;
}
function split_0(_this__u8e3s4) {
  return new (Split())(_this__u8e3s4);
}
function beforeSetup_4(_this__u8e3s4, setup) {
  return new (BeforeSetup())(_this__u8e3s4, setup);
}
function beforeSetup_5(_this__u8e3s4, setup) {
  return new (BeforeSetup())(_this__u8e3s4, setup);
}
//region block: exports
export {
  beforeSetup as beforeSetup1a13mbd699ddp,
  beforeSetup_4 as beforeSetup2j3kmslavpq8h,
  beforeSetup_5 as beforeSetupui10dg5zhiof,
  beforeSetup_0 as beforeSetupw9y6lebwkk6y,
  beforeSetup_2 as beforeSetupo2ti5mxo1sd1,
  beforeSetup_1 as beforeSetupsr6thgzteo9n,
  beforeSetup_3 as beforeSetuptvxu5ozf0s97,
  split_0 as split2t92a14m1lc15,
  split as split3oko73n02120n,
};
//endregion

//# sourceMappingURL=ElementWriter.ext.mjs.map
